import { Project, User } from '../types';

export interface ProjectDepartmentRef {
  id: number;
  department: string;
}

export type NdTeamOption =
  | { kind: 'department'; id: number; label: string }
  | { kind: 'user'; id: number; label: string; departmentName?: string };

export function ndTeamOptionKey(option: NdTeamOption): string {
  return `${option.kind}:${option.id}`;
}

export function buildNdTeamOptions(
  users: User[],
  departments: ProjectDepartmentRef[],
  pmId?: string,
): NdTeamOption[] {
  const departmentOptions: NdTeamOption[] = departments.map((dept) => ({
    kind: 'department',
    id: dept.id,
    label: dept.department,
  }));

  const peopleOptions: NdTeamOption[] = users
    .filter((user) => user.id.toString() !== (pmId || ''))
    .map((user) => ({
      kind: 'user' as const,
      id: user.id,
      label: user.name,
      departmentName: user.department_name,
    }));

  return [...departmentOptions, ...peopleOptions];
}

export function selectedNdTeamOptions(
  options: NdTeamOption[],
  engineerIds: string[],
  departmentIds: string[],
): NdTeamOption[] {
  const engineerSet = new Set(engineerIds);
  const departmentSet = new Set(departmentIds);
  return options.filter((option) => (
    option.kind === 'user'
      ? engineerSet.has(option.id.toString())
      : departmentSet.has(option.id.toString())
  ));
}

export function splitNdTeamSelection(selected: NdTeamOption[]): {
  engineer_ids: string[];
  department_ids: string[];
} {
  return {
    engineer_ids: selected.filter((option) => option.kind === 'user').map((option) => option.id.toString()),
    department_ids: selected.filter((option) => option.kind === 'department').map((option) => option.id.toString()),
  };
}

export function isUserOnProjectTeam(
  project: Pick<Project, 'pm_id' | 'engineers' | 'departments'>,
  user: Pick<User, 'id' | 'department'> | null | undefined,
): boolean {
  if (!user) {
    return false;
  }
  if (project.pm_id === user.id) {
    return true;
  }
  if (project.engineers?.some((engineer) => engineer.id === user.id)) {
    return true;
  }
  if (user.department && project.departments?.some((dept) => dept.id === user.department)) {
    return true;
  }
  return false;
}

export function hasNdTeamAssignment(engineerIds: string[], departmentIds: string[]): boolean {
  return engineerIds.length > 0 || departmentIds.length > 0;
}
